import { FC } from "react"

import { PrecertFormField } from "src/pages/precert/types"



const LabelInputComp: FC<PrecertFormField> = ({ label, display, isHidden }): JSX.Element => {
  return display ? (
    <div className={`row py-3 ${isHidden ? "d-none" : ""}`}>
      <label className="col-sm-6 form-label text-end precert-form-label">
        {label}{label.includes(":") || ":"}
      </label>
    </div>
  ) : <></>
}

export default LabelInputComp
